export default function MySQL_TAN() {
  return (
    <div>
      <h2>MySQL_TAN</h2>    </div>
  );
}